import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import QuestionNavigator from "./QuestionNavigator";
import "../../styles/testFooter.css";

const TestFooter = ({
  currentIndex,
  totalQuestions,
  setCurrentIndex,
  answers,
  marked,
  isReviewPage,
  isReadOnly,
  onSubmit,
  onExit,
  isDiagnostic = false,
  canAdvance = true,
  isReviewMode = false,
  correctness = null,
}) => {
  const [navOpen, setNavOpen] = useState(false);

  const goBack = () => {
    if (isDiagnostic || !setCurrentIndex) return;
    setCurrentIndex((i) => Math.max(0, i - 1));
  };

  const goNext = () => {
    // Diagnostic: adaptive advance only
    if (isDiagnostic) {
      onSubmit?.();
      return;
    }

    // Normal packet behavior
    if (isReviewPage) {
      if (isReadOnly) {
        onExit?.();
      } else {
        onSubmit?.();
      }
      return;
    }

    setCurrentIndex((i) => Math.min(totalQuestions, i + 1));
  };

  const nextLabel = isDiagnostic
    ? "Next"
    : isReviewPage
    ? isReadOnly
      ? "Exit"
      : "Submit"
    : currentIndex === totalQuestions - 1
    ? "Review"
    : "Next";

  return (
    <>
      <div className="test-footer-wrapper">
        <div className="test-footer-dashed" />

        <div className="test-footer">
          {/* Left */}
          <Box className="test-footer-left">
            <div className="test-footer-name">Leaf Kalikow</div>
          </Box>

          {/* Center */}
          <Box className="test-footer-center">
            {!isReviewPage && !isDiagnostic && (
              <div
                className="question-selector"
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={() => setNavOpen((v) => !v)}
              >
                <div className="question-selector-text">
                  Question {currentIndex + 1} of {totalQuestions}
                </div>
                <ArrowDropDownIcon className="question-selector-arrow" />
              </div>
            )}
          </Box>

          {/* Right */}
          <Box className="test-footer-right">
            {!isDiagnostic && (
              <Button
                onClick={goBack}
                disabled={currentIndex === 0}
                variant="contained"
                sx={{
                  borderRadius: "25px",
                  py: 1,
                  px: 2.75,
                  fontWeight: 600,
                  textTransform: "none",
                }}
              >
                Back
              </Button>
            )}

            <Button
              onClick={goNext}
              disabled={isDiagnostic && !canAdvance}
              variant="contained"
              sx={{
                borderRadius: "25px",
                py: 1,
                px: 2.75,
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              {nextLabel}
            </Button>
          </Box>
        </div>
      </div>

      {!isDiagnostic && (
        <QuestionNavigator
          open={navOpen}
          onClose={() => setNavOpen(false)}
          currentIndex={currentIndex}
          answers={answers}
          marked={marked}
          onJump={(idx) => {
            setCurrentIndex(idx);
            setNavOpen(false);
          }}
          isReviewMode={isReviewMode}
          correctness={correctness}
        />
      )}
    </>
  );
};

export default TestFooter;
